import * as React from "react";
import getConfig from "next/config";
import { CmsComponentSlot, CmsHeadTags, isPreviewMode } from "@grandvisionhq/bloomreach";
import { Pages, Components, Operations } from "@grandvisionhq/fun-returns";
import { useIntl } from "@grandvisionhq/state";
import { LocaleUtils } from "@grandvisionhq/utils";
import { e as errorResponse, g as getQueryParams } from "../../error-response.js";
const { publicRuntimeConfig } = getConfig();
const PageLayout = (props) => {
  const { lineItems, returnLabelUrl } = props;
  return /* @__PURE__ */ React.createElement(Pages.PageLayout, { bottomContainerSlot: /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/bottom-container" }) }, /* @__PURE__ */ React.createElement(Pages.ConfirmationPage, { lineItems, returnLabelUrl }));
};
const Page = (props) => {
  const { getLabel } = useIntl();
  if (props.redirect) {
    return /* @__PURE__ */ React.createElement(
      Components.RedirectionWrapper,
      {
        email: props.email,
        orderNumber: props.orderNumber,
        redirect: props.redirect
      }
    );
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    CmsHeadTags,
    {
      title: getLabel("returns.page.confirmation.title"),
      noFollow: true,
      noIndex: true
    }
  ), /* @__PURE__ */ React.createElement(PageLayout, { ...props }));
};
Page.getInitialProps = async (context) => {
  const { apolloClient, pathname, query, asPath, req } = context;
  const defaultLocale = publicRuntimeConfig.defaultLocale;
  const locale = req ? LocaleUtils.getLocale(req, defaultLocale, false) : defaultLocale;
  const preview = isPreviewMode(query);
  if (!apolloClient) {
    console.error(`ApolloClient not present in context for page ${pathname}`);
    return errorResponse();
  }
  const { email, orderNumber } = getQueryParams(
    query,
    asPath,
    ["email", "orderNumber"]
  );
  if (preview) {
    return {};
  } else if (!email || !orderNumber) {
    return {
      redirect: {
        page: "login",
        reason: "missingCredentials"
      }
    };
  }
  const { data: returnData, failures } = await Operations.ReturnQueryService.getForConfirmation({
    client: apolloClient,
    email,
    orderNumber,
    locale
  });
  const hasFailures = !!failures?.length;
  if (hasFailures) {
    return {
      email,
      orderNumber,
      redirect: {
        page: "login",
        reason: failures[0]
      }
    };
  }
  if (!returnData) {
    return {
      email,
      orderNumber,
      redirect: {
        page: "login",
        reason: "unknownError"
      }
    };
  }
  return {
    email,
    orderNumber,
    returnLabelUrl: returnData.returnLabelUrl,
    lineItems: returnData.returnInfo[0]?.items ?? []
    //TODO: handle multiple returnInfo items (one per order)
  };
};
export {
  Page,
  PageLayout
};
//# sourceMappingURL=confirmation.js.map
